
  import React, { Component } from 'react';
  import PropTypes from 'prop-types';
  import { connect } from 'react-redux';
  import clone from 'clone';
  import moment from 'moment-timezone';
  import {
    Button,
    Grid,
    Header,
    Icon,
    Segment,
  } from 'semantic-ui-react';
  import { withTranslation } from 'react-i18next';
  // components
  import UploadModal from './UploadModal';
  // containers
  import DeleteConfirm from '../containers/modals/DeleteConfirm';
  import UploadAttachmentForm from '../containers/BookingPaymentPictures/Form';
  // utils
  import fileSize from '../utils/fileSize';
  import { AWSUrl } from '../utils/url';
  import { TRANSLATION_FILES } from '../constants/translation';
  import Timestamp from './Timestamp';

  // Still needed for the module-level locale; the upload time renders through Timestamp.
  moment.locale('en-gb');

  class BookingAttachment extends Component {
    static propTypes = {
      appConfig: PropTypes.shape({
        data: PropTypes.shape({
          noeticIsEnabled: PropTypes.bool,
          lawyerIsEnabled: PropTypes.bool,
        }),
      }),
      onRef: PropTypes.func,
      onSubmit: PropTypes.func,
      onDelete: PropTypes.func,
      data: PropTypes.shape({
        bookingAttachments: PropTypes.array,
      }),
      isMobile: PropTypes.bool,
      loading: PropTypes.bool,
      uploadModalState: PropTypes.bool,
    }
    static mapStateToProps = state => ({
      appConfig: state.appConfig,
    })
    static getPropsToState = (props) => {
      const data = Object.assign({}, props.data);
      const loading = props.loading;
      const uploadModalState = props.uploadModalState;
      const errMessages = [];
      return {
        data,
        errMessages,
        loading,
        oriData: clone(data),
        uploadModalState,
      };
    }
    constructor(props) {
      super(props);
      const state = BookingAttachment.getPropsToState(props);
      this.state = {
        ...state,
        loading: false,
        showDeleteAttachmentConfirm: false,
        deleteFile: null,
      };
      this.validation = {};
    }
    componentDidMount() {
      this.props.onRef(this);
    }
    componentWillReceiveProps(nextProps) {
      const state = BookingAttachment.getPropsToState(nextProps);
      // don't allow state to override data if oriData is same
      if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
        state.data = this.state.data;
      }
      this.setState({ ...state });
    }
    componentWillUnmount() {
      this.props.onRef(undefined);
    }
    handleUploadModalClose = () => {
      this.setState({ uploadModalState: false });
    }
    handleCancelDeleteAttachment = (e) => {
      e.preventDefault();
      this.setState({
        showDeleteAttachmentConfirm: false,
        deleteFile: null,
      });
    }
    handleConfirmDeleteAttachment = (e) => {
      e.preventDefault();
      const fileID = this.state.deleteFile.id;
      this.setState({
        showDeleteAttachmentConfirm: false,
        deleteFile: null,
      }, () => {
        this.props.onDelete(fileID);
      });
    }
    handleDeleteAttachment = (e, file) => {
      e.preventDefault();
      this.setState({
        showDeleteAttachmentConfirm: true,
        deleteFile: file,
      });
    }
    handleUploadDocs = (e, file) => {
      e.preventDefault();
      this.props.onSubmit(file);
    }
    triggerAddAttachment = () => {
      this.setState({ uploadModalState: true });
    }
    render() {
      const { data, deleteFile, uploadModalState } = this.state;
      const { isMobile, t } = this.props;
      return (
        <div>
          <Header className="new_title" as="h5" attached="top" textAlign="center">
            {t('Attachment').toUpperCase()}
          </Header>
          <Segment attached>
            <UploadModal
              modalState={uploadModalState}
              trigger={(<span />)}
              ref={(ref) => { this.uploadModal = ref; }}
              header="attachments"
              loading={this.state.loading}
              onConfirm={(e, file) => this.handleUploadDocs(e, file)}
              onClose={this.handleUploadModalClose}
              primary={false}
              content={opt => (
                <UploadAttachmentForm
                  ref={(ref) => { this.form = ref; }}
                  fileType="attachment"
                  loading={this.state.loading}
                  onSubmit={opt.onConfirm}
                  btnText="Attachments"
                />
              )}
            />
            <DeleteConfirm
              open={this.state.showDeleteAttachmentConfirm}
              onClose={this.handleCancelDeleteAttachment}
              onConfirm={this.handleConfirmDeleteAttachment}
              name={deleteFile ? deleteFile.name : ''}
            />
            <Grid>
              <Grid.Row>
                <Grid.Column textAlign="center">
                  <p>
                    {t('You may upload documents / attachments at the Document Sharing tab above. This section will no longer be supported')}.
                    <br />
                    {t('Your previous uploads will still remain')}.
                  </p>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  {
                    data.bookingAttachments && data.bookingAttachments.length > 0 ? (
                      <span>
                        {
                          data.bookingAttachments.map((file, id) => (
                            <Segment key={id}>
                              <Grid
                                columns="equal"
                                verticalAlign="middle"
                                as="a"
                              >
                                <Grid.Column
                                  mobile={16}
                                  tablet={13}
                                  computer={13}
                                  textAlign={isMobile ? 'center' : 'left'}
                                  href={AWSUrl(
                                    this.props.appConfig,
                                    encodeURI(file.key),
                                  )}
                                  target="_blank"
                                  style={isMobile ? { paddingBottom: '0.5em', overflowX: 'hidden' } : { overflowX: 'hidden' }}
                                >
                                  <Icon name="file image outline" />
                                  {file.name}
                                  <span className="mobile-hide"> ({fileSize(file.size)})</span>
                                  <small className="large-hide small-hide tablet-hide"><br />{fileSize(file.size)}</small>
                                </Grid.Column>
                                <Grid.Column
                                  mobile={16}
                                  tablet={3}
                                  computer={3}
                                  textAlign={isMobile ? 'center' : 'right'}
                                  style={isMobile ? { paddingTop: '0.5em' } : {}}
                                >
                                  <small style={{ paddingRight: '1em' }}>
                                    <Timestamp timestamp={file.createdAt} format="DD/MM/YY hh:mm a" />
                                  </small>
                                  <Button
                                    compact
                                    negative
                                    type="button"
                                    size="tiny"
                                    icon="trash"
                                    onClick={e => this.handleDeleteAttachment(e, file)}
                                  />
                                </Grid.Column>
                              </Grid>
                            </Segment>
                          ))
                        }
                      </span>
                    ) : null
                  }
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </div>
      );
    }
  }

  export default withTranslation(TRANSLATION_FILES.screens)(connect(BookingAttachment.mapStateToProps)(BookingAttachment));



// WEBPACK FOOTER //
// ./src/components/BookingAttachment.jsx